import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { ROUTE_PATHS } from "const/paths";
import { useAuth } from "hooks/useAuth";
import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useUserContext } from "contexts/UserContext";
import { ItemType } from "antd/es/menu/hooks/useItems";

import { filterMenuItemsWithAuth } from "./utils";
import { MAIN_MENU_ITEMS } from "./consts";

export const useMenuItems = (): ItemType[] => {
  const { signOut } = useAuth();
  const { user } = useUserContext();
  const { userPermissions = [], venuePermissions = [] } = user || {};

  return useMemo(
    () =>
      filterMenuItemsWithAuth(
        [
          { type: "divider" },
          ...MAIN_MENU_ITEMS,
          { type: "divider" },
          {
            label: <FormattedMessage defaultMessage="Settings" />,
            children: [
              {
                label: (
                  <Link to={ROUTE_PATHS.SettingsVenueUserList}>
                    <FormattedMessage defaultMessage="Settings" />
                  </Link>
                ),
                nestedKeys: [
                  ROUTE_PATHS.SettingsUsers,
                  ROUTE_PATHS.SettingsPayments,
                  ROUTE_PATHS.PaymentTerminalsList,
                  ROUTE_PATHS.Embed,
                ],
                key: ROUTE_PATHS.SettingsVenueUserList,
                icon: <SettingOutlined />,
              },
              {
                label: <FormattedMessage defaultMessage="Logout" />,
                key: ROUTE_PATHS.Login,
                icon: <LogoutOutlined />,
                onClick: async () => {
                  await signOut();
                  window.location.pathname = ROUTE_PATHS.Login;
                },
              },
            ],
            type: "group",
          },
        ],
        [...userPermissions, ...venuePermissions]
      ),
    [signOut, userPermissions, venuePermissions]
  );
};
